import sourceSerifSemiBold from "../../src/assets/fonts/SourceSerif4-SemiBold.ttf";
import sourceSerifRegular from "../../src/assets/fonts/SourceSerif4-Regular.ttf";
import geistMonoRegular from "../../src/assets/fonts/GeistMono-Regular.ttf";
import sourceSerifItalic from "../../src/assets/fonts/SourceSerif4-It.ttf";
import geistExtraLight from "../../src/assets/fonts/Geist-ExtraLight.ttf";
import geistExtraBold from "../../src/assets/fonts/Geist-ExtraBold.ttf";
import geistSemiBold from "../../src/assets/fonts/Geist-SemiBold.ttf";
import geistRegular from "../../src/assets/fonts/Geist-Regular.ttf";
import geistMedium from "../../src/assets/fonts/Geist-Medium.ttf";
import geistBlack from "../../src/assets/fonts/Geist-Black.ttf";
import geistLight from "../../src/assets/fonts/Geist-Light.ttf";
import geistBold from "../../src/assets/fonts/Geist-Bold.ttf";
import geistThin from "../../src/assets/fonts/Geist-Thin.ttf";

const GEIST_FACES: Array<{
    source: string;
    weight: number;
}> = [
    {
        source: geistThin,
        weight: 100
    },
    {
        source: geistExtraLight,
        weight: 200
    },
    {
        source: geistLight,
        weight: 300
    },
    {
        source: geistRegular,
        weight: 400
    },
    {
        source: geistMedium,
        weight: 500
    },
    {
        source: geistSemiBold,
        weight: 600
    },
    {
        source: geistBold,
        weight: 700
    },
    {
        source: geistExtraBold,
        weight: 800
    },
    {
        source: geistBlack,
        weight: 900
    }
];

const SOURCE_SERIF_FACES: Array<{
    source: string;
    weight: number;
    style: string;
}> = [
    {
        source: sourceSerifRegular,
        style: "normal",
        weight: 400
    },
    {
        source: sourceSerifItalic,
        style: "italic",
        weight: 400
    },
    {
        source: sourceSerifSemiBold,
        style: "normal",
        weight: 600
    }
];

export const getFontCss = () => {
    const geistFaces = GEIST_FACES.map(({
        source,
        weight
    }) => `@font-face { font-family: "Geist"; font-weight: ${weight}; font-style: normal; font-display: swap; src: url("${source}") format("truetype"); }`);

    const sourceSerifFaces = SOURCE_SERIF_FACES.map(({
        source,
        weight,
        style
    }) => `@font-face { font-family: "Source Serif 4"; font-weight: ${weight}; font-style: ${style}; font-display: swap; src: url("${source}") format("truetype"); }`);

    return [
        ...geistFaces,
        `@font-face { font-family: "Geist Mono"; font-weight: 400; font-style: normal; font-display: swap; src: url("${geistMonoRegular}") format("truetype"); }`,
        ...sourceSerifFaces
    ].join("\n");
};
